'use strict';
var React = require('react');
var FormatMessage = require('react-globalize').FormatMessage;

// var ESignEN = require('../public/documents/e-signEN.js');
// var ESignES = require('../public/documents/e-signES.js');

var SectionList = React.createClass({

  /**
   * @return {object}
   */
  render: function () {
    return <div>
      <FormatMessage locale={this.props.locale} path="compliancePage/customerDescription2" /><br /><br />
      <div className="row">
        <div className="col-sm-8 col-xs-8">
          <ul><li><FormatMessage locale={this.props.locale} path="compliancePage/customerList1" /></li>
            <li><FormatMessage locale={this.props.locale} path="compliancePage/customerList2" /></li>
            <li><FormatMessage locale={this.props.locale} path="compliancePage/customerList3" /></li>
          </ul><br /><br />
        </div>
      </div>
      <FormatMessage locale={this.props.locale} path="compliancePage/customerDescription3" /><br /><br />
    </div>
  }
});

const statesLLC = [
  { name: 'Alabama', license: '4512', type: 'Money Transmitter License', agency: 'Alabama Securities Commission', link: 'http://asc.state.al.us/contact.aspx' },
  { name: 'Alaska', license: 'AKMT-013999', type: 'Money Transmitter License', agency: 'Alaska Division of Banking & Securities', link: 'https://www.commerce.alaska.gov/' },
  { name: 'Arizona', license: 'MT- 937887', type: 'Money Transmitter', agency: 'Arizona Department of Insurance and Financial Institutions', link: 'https://difi.az.gov/' },
  { name: 'Arkansas', license: '43369', type: 'Money Transmitter License', agency: 'Arkansas Securities Department', link: 'https://securities.arkansas.gov/' },
  { name: 'California', license: '2668', type: 'Money Transmitter', agency: 'California Department of Financial Protection and Innovation', link: 'http://www.dfpi.ca.gov' },
  { name: 'Colorado', license: '500281', type: 'Money Transmitter', agency: 'Colorado Division of Banking', link: 'https://www.colorado.gov/dora/division-banking' },
  { name: 'Connecticut', license: 'MT-937962', type: 'Money Transmission', agency: 'Connecticut Department of Banking', link: 'https://portal.ct.gov/dob', license2: 'CC-937962', type2: 'Check Cashing License', agency2: 'Connecticut Department of Banking', link2: 'https://portal.ct.gov/dob' },

  { name: 'Delaware', license: '31515', type: 'Sale of checks and transmission of money', agency: 'Delaware Office of the State Bank Commissioner', link: 'https://banking.delaware.gov/' },
  { name: 'District of Columbia', license: 'MTR937962', type: 'Money Transmitter License', agency: 'Department of Insurance, Securities and Banking', link: 'https://disb.dc.gov/' },
  { name: 'Florida', license: 'FT230000136', type: 'Money Transmitters Part II', agency: 'Florida Office of Financial Regulation- Division of Securities and Finance', link: 'https://www.flofr.com/' },
  { name: 'Georgia', license: '43322', type: 'Selling Payment Instruments', agency: 'Georgia Department of Banking and Finance', link: 'https://dbf.georgia.gov/', license2: '43825', type2: 'Check Casher License', agency2: 'Georgia Department of Banking and Finance', link2: 'https://dbf.georgia.gov/' },
  
  { name: 'Idaho', license: 'MTL-236', type: 'Money Transmitter', agency: 'Idaho Department of Finance', link: 'http://www.finance.idaho.gov/' },
  { name: 'Illinois', license: 'MT.0000307', type: 'Transmitter of Money', agency: 'Illinois Department of Financial and Professional Regulation (IDFPR)', link: 'http://idfpr.com/' },
  { name: 'Indiana', license: '45673', type: 'Money Transmitter', agency: 'Indiana Department of Financial Institutions', link: 'http://www.in.gov/dfi' },
  { name: 'Iowa', license: '2019-0007', type: 'Money Services License', agency: 'Iowa Division of Banking Finance Bureau', link: 'https://idob.iowa.gov/' },
  { name: 'Kansas', license: 'MT.0000105', type: 'Money Transmitter', agency: 'Kansas Office of the State Bank Commissioner', link: 'http://www.osbckansas.org/' },
  { name: 'Kentucky', license: 'SC700761', type: 'Money Transmitter', agency: 'Kentucky Department of Financial Institutions', link: 'https://kfi.ky.gov/' },
  { name: 'Louisiana', license: '374', type: 'Sale of Checks and Money Transmitters', agency: 'Louisiana Office of Financial Institutions', link: 'https://ofi.la.gov/', license2: '2636', type2: 'Check Casher License', agency2: 'Louisiana Office of Financial Institutions', link2: 'https://ofi.la.gov/' },

  { name: 'Maine', license: 'No number', type: 'Money Transmitter License', agency: 'Department of Professional and Financial Regulation', link: 'https://www.maine.gov/pfr/home' },
  { name: 'Maryland', license: '937962', type: 'Money Transmitter', agency: 'Maryland Office of the Commissioner of Financial Regulation', link: 'http://www.dllr.state.md.us/finance/', license2: '937962', type2: 'Check Cashing Services License', agency2: 'Maryland Office of the Commissioner of Financial Regulation', link2: 'http://www.dllr.state.md.us/finance/' }, 

  { name: 'Massachusetts', license: 'FT937962', type: 'Foreign Transmittal Agency', agency: 'Massachusetts Division of Banks', link: 'http://www.mass.gov/dob' },
  { name: 'Michigan', license: 'MT0020894', type: 'Money Transmitter', agency: 'Michigan Department of Financial and Insurance Services', link: 'https://www.michigan.gov/difs' },
  { name: 'Minnesota', license: 'MN-MT-937962', type: 'Money Transmitter License', agency: 'Minnesota Department of Commerce', link: 'https://mn.gov/commerce/' },
  { name: 'Mississippi', license: '2534', type: 'Money Transmitter License', agency: 'Department of Banking and Consumer Finance', link: 'https://dbcf.ms.gov/' },
  { name: 'Missouri', license: 'MO-23-7801', type: 'Sale of Checks and Money Transmitter License', agency: 'Missouri Division of Finance', link: 'http://finance.mo.gov/' },
  { name: 'Nebraska', license: 'No number', type: 'Money Transmitter License', agency: 'Nebraska Department of Banking and Finance', link: 'https://ndbf.nebraska.gov/' },
  { name: 'Nevada', license: 'MT11203', type: 'Money Transmitter', agency: 'Nevada Financial Institutions Division', link: 'http://fid.nv.gov/' },
  { name: 'New Jersey', license: '2305801 C22', type: 'Money Transmitter', agency: 'New Jersey Department of Banking and Insurance', link: 'http://www.state.nj.us/dobi/index.html' },
  { name: 'New Hampshire', license: '23714-MT', type: 'Money Transmitter License', agency: 'State of NH Banking Department', link: 'https://www.banking.nh.gov/' },
  { name: 'New Mexico', license: 'No number', type: 'Money Transmitter License', agency: 'Financial Institutions Division', link: 'https://www.rld.nm.gov/financial-institutions/', license2: 'No number', type2: 'Check Casher License', agency2: 'Financial Institutions Division', link2: 'https://www.rld.nm.gov/financial-institutions/' },

  { name: 'New York', license: 'MT-105096', type: 'Money Transmission', agency: 'New York State Department of Financial Services', link: 'https://www.dfs.ny.gov/complaint' },
  { name: 'North Carolina', license: '164586', type: 'Money Transmitter License', agency: 'North Carolina Commissioner of Banks', link: 'https://www.nccob.org/', license2: '1880437-4', type2: 'Check cashing License', agency2: 'North Carolina Commissioner of Banks', link2: 'https://www.nccob.org/' },

  { name: 'North Dakota', license: 'MT103382', type: 'Money Transmitter License', agency: 'ND Dept. of Financial Institutions', link: 'https://www.nd.gov/dfi/' },
  { name: 'Ohio', license: 'OHMT156', type: 'Money Transmitter License', agency: 'Ohio Division of Financial Institutions', link: 'https://com.ohio.gov/divisions-and-programs/financial-institutions/financial-institutions', license2: 'CC-700888.000', type2: 'Check-Cashing License', agency2: 'Ohio Division of Financial Institutions', link2: 'https://com.ohio.gov/divisions-and-programs/financial-institutions/financial-institutions' },
  
  { name: 'Oklahoma', license: 'OKDOB001', type: 'Money Transmission License', agency: 'Oklahoma Banking Department', link: 'https://www.ok.gov/banking/' },
  { name: 'Oregon', license: '937962', type: 'Money Transmitter', agency: 'Oregon Division of Financial Regulation', link: 'http://dfr.oregon.gov/' },
  { name: 'Pennsylvania', license: '75303', type: 'Money Transmitter License', agency: 'Pennsylvania Department of Banking and Securities', link: 'http://www.banking.state.pa.us/' },
  { name: 'Puerto Rico', license: 'TM-111', type: 'Money Transmitter License', agency: 'Puerto Rico Oficina del Comisionado de Instituciones Financieras', link: 'http://www.ocif.pr.gov/' },
  { name: 'Rhode Island', license: '20203898CT', type: 'Currency Transmitter License', agency: 'Rhode Island Department of Business Regulation', link: 'https://dbr.ri.gov/divisions/banking/' },
  { name: 'South Carolina', license: 'No number', type: 'Money Transmission License', agency: 'South Carolina Office of the Attorney General', link: 'http://www.scag.gov/civil/money-services' },
  { name: 'South Dakota', license: '937962.MT', type: 'Money Transmitter License', agency: 'South Dakota Division of Banking', link: 'https://dlr.sd.gov/banking/default.aspx' },
  { name: 'Tennessee', license: '937962', type: 'Money Transmitter License', agency: 'Tennessee Department of Financial Institutions', link: 'http://www.tennessee.gov/tdfi/', license2: '168822', type2: 'Check Casher License', agency2: 'Tennessee Department of Financial Institutions', link2: 'http://www.tennessee.gov/tdfi/' },
  
  { name: 'Texas', license: '2301', type: 'Money Transmitter License', agency: 'Texas Department of Banking', link: 'http://www.dob.texas.gov/' },
  { name: 'Utah', license: '145', type: 'Money Transmitter License', agency: 'Utah Department of Financial Institutions', link: 'https://dfi.utah.gov/', license2: 'No number', type2: 'Check Casher License', agency2: 'Department of Financial Institutions', link2: 'https://dfi.utah.gov/' },

  { name: 'Vermont', license: '100-128', type: 'Money Transmitter License', agency: 'Vermont Department of Financial Regulation', link: 'https://dfr.vermont.gov/' },
  { name: 'Virginia', license: 'MO-406', type: 'Money Order Seller and Money Transmitter License', agency: 'Virginia State Corporation Commission - Bureau of Financial Institutions', link: 'http://www.scc.virginia.gov/bfi/index.aspx' },
  { name: 'Washington', license: '550-MT-117332', type: 'Money Transmission License', agency: 'Washington State Department of Financial Institutions', link: 'https://dfi.wa.gov/', license2: '530-CC-117331', type2: 'Check Casher License', agency2: 'Washington State Department of Financial Institutions', link2: 'http://www.dfi.wa.gov/' },

  { name: 'West Virginia', license: 'WVMT-937962', type: 'Money Transmitter License', agency: 'Division of Financial Institutions', link: 'https://dfi.wv.gov/Pages/default.aspx' },
  { name: 'Wisconsin', license: '205-SOC', type: 'Sale of Checks', agency: 'Wisconsin Department of Financial Institutions', link: 'http://wdfi.org/' },
  { name: 'Wyoming', license: '7254', type: 'Money Transmitter License', agency: 'Wyoming Division of Banking', link: 'https://wyomingbankingdivision.wyo.gov/' } 
]

var BfgStatesLLC = React.createClass({

  render: function () {
    var message = "";

    if (this.props.locale == 'en') {
      message = <SectionList locale={this.props.locale} />;
    }
    console.log("locale", this.props.locale)
    return (

      <div className="container" style={{ "marginTop": "5%", "marginBottom": "5%" }}>
        <div className="row" style={{ "marginTop": "3%", "marginBottom": "2%" }}>

          <h3 className="text-center">
            LICENSES
          </h3>

          <hr className="small-blue" />

          <h4 className="text-center">
            NMLS# 937962 issued by the Nationwide Multistate Licensing System and Registry.
          </h4>

        </div>
        <div className="row text-justify">
          {this.renderLicencesTable()}
        </div>
      </div>
    )
  },
  /**
   * function that iterates by 2 and sum by 1 to display multiple columns
   * @returns 
   */
  renderStateLLC: function () {
    let html = []
    for (let index = 0; index < statesLLC.length; index += 2) {
      html.push(
        <tr>
          <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
            <b>{statesLLC[index].name}</b><br/>
            <b>License:</b> {statesLLC[index].license}<br/>
            <b>Type:</b> {statesLLC[index].type}<br/>
            <b>State Agency:</b> {statesLLC[index].agency + ' '}
              (<a target='_blank' href={statesLLC[index].link} >{statesLLC[index].link}</a>)
              {/* if the first column has the second active license, the following is displayed */}
            { statesLLC[index].license2 && <div>
                <br/><br/>
                <b>License:</b> {statesLLC[index].license2}<br/>
                <b>Type:</b> {statesLLC[index].type2}<br/>
                <b>State Agency:</b> {statesLLC[index].agency2 + ' '} 
                  (<a target='_blank' href={statesLLC[index].link2}>{statesLLC[index].link2}</a>)
              </div>
            }
          </td>
          {/*if the second column exists, it is displayed*/}
          { (statesLLC[index + 1]) &&
            <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
              <b>{statesLLC[index + 1].name}</b><br/>
              <b>License:</b> {statesLLC[index + 1].license}<br/>
              <b>Type:</b> {statesLLC[index + 1].type}<br/>
              <b>State Agency:</b> {statesLLC[index + 1].agency + ' '} 
                (<a target='_blank' href={statesLLC[index + 1].link}>{statesLLC[index + 1].link}</a>)
                {/* if the second column has the second active license, the following is displayed */}
              { statesLLC[index + 1].license2 && <div>
                  <br/><br/>
                  <b>License:</b> {statesLLC[index + 1].license2}<br/>
                  <b>Type:</b> {statesLLC[index + 1].type2}<br/>
                  <b>State Agency:</b> {statesLLC[index + 1].agency2 + ' '} 
                    (<a target='_blank' href={statesLLC[index + 1].link2}>{statesLLC[index + 1].link2}</a>)
                </div>
              }
            </td>
          }
        </tr>
      )
    }
    return html
  },


  renderLicencesTable: function () {
    return (
      <div className="col-xs-10 col-md-10 col-lg-12">
        <table className="table table-bordered">
          <tbody>
            {this.renderStateLLC()}
            {/* <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Alabama</b><br/>
                <b>License:</b> 4512<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> Alabama Securities Commission 
                  (<a target='_blank' href='http://asc.state.al.us/contact.aspx' >http://asc.state.al.us/contact.aspx</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Alaska</b><br/>
                <b>License:</b> AKMT-013999<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> Alaska Division of Banking & Securities 
                  (<a target='_blank' href='https://www.commerce.alaska.gov/'>https://www.commerce.alaska.gov/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Arizona</b><br/>
                <b>License:</b> MT- 937887<br/>
                <b>Type:</b> Money Transmitter<br/>
                <b>State Agency:</b> Arizona Department of Insurance and Financial Institutions
                  (<a target='_blank' href='https://difi.az.gov/'>https://difi.az.gov/</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Arkansas</b><br/>
                <b>License:</b> 43369<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> Arkansas Securities Department
                  (<a target='_blank' href='https://securities.arkansas.gov/'>https://securities.arkansas.gov/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>California</b><br/>
                <b>License:</b> 2668<br/>
                <b>Type:</b> Money Transmitter<br/>
                <b>State Agency:</b> California Department of Financial Protection and Innovation
                  (<a target='_blank' href='http://www.dfpi.ca.gov'>http://www.dfpi.ca.gov</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Colorado</b><br/>
                <b>License:</b> 500281<br/>
                <b>Type:</b> Money Transmitter<br/>
                <b>State Agency:</b> Colorado Division of Banking
                  (<a target='_blank' href='https://www.colorado.gov/dora/division-banking'>https://www.colorado.gov/dora/division-banking</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Connecticut</b><br/>
                <b>License:</b> MT-937962<br/>
                <b>Type:</b> Money Transmission<br/>
                <b>State Agency:</b> Connecticut Department of Banking
                  (<a target='_blank' href='https://portal.ct.gov/dob'>https://portal.ct.gov/dob</a>) 
                <br/><br/>
                <b>License:</b> CC-937962<br/>
                <b>Type:</b> Check Cashing License<br/>
                <b>State Agency:</b> Connecticut Department of banking
                  (<a target='_blank' href='https://portal.ct.gov/dob'>https://portal.ct.gov/dob</a>)  
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Delaware</b><br/>
                <b>License:</b> 31515<br/>
                <b>Type:</b> Sale of checks and transmission of money<br/>
                <b>State Agency:</b> Delaware Office of the State Bank Commissioner
                  (<a target='_blank' href='https://banking.delaware.gov/'>https://banking.delaware.gov/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>District of Columbia</b><br/>
                <b>License:</b> MTR937962<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> Department of Insurance, Securities and Banking
                  (<a target='_blank' href='https://disb.dc.gov/'>https://disb.dc.gov/</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Florida</b><br/>
                <b>License:</b> FT230000136<br/>
                <b>Type:</b> Money Transmitters Part II<br/>
                <b>State Agency:</b> Florida Office of Financial Regulation- Division of Securities and Finance
                  (<a target='_blank' href='https://www.flofr.com/'>https://www.flofr.com/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Georgia</b><br/>
                <b>License:</b> 43322<br/>
                <b>Type:</b> Selling Payment Instruments<br/>
                <b>State Agency:</b> Georgia Department of Banking and Finance
                  (<a target='_blank' href='https://dbf.georgia.gov/'>https://dbf.georgia.gov/</a>)
                <br/><br/>
                <b>License:</b> 43825<br/>
                <b>Type:</b> Check Casher License<br/>
                <b>State Agency:</b> Georgia Department of Banking and Finance
                  (<a target='_blank' href='https://dbf.georgia.gov/'>https://dbf.georgia.gov/</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Idaho</b><br/>
                <b>License:</b> MTL-236 <br/>
                <b>Type:</b> Money Transmitter<br/>
                <b>State Agency:</b> Idaho Department of Finance
                  (<a target='_blank' href='http://www.finance.idaho.gov/'>http://www.finance.idaho.gov/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Illinois</b><br/>
                <b>License:</b> MT.0000307<br/>
                <b>Type:</b> Transmitter of Money<br/>
                <b>State Agency:</b> Illinois Department of Financial and Professional Regulation (IDFPR)
                  (<a target='_blank' href='http://idfpr.com/'>http://idfpr.com/</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Indiana</b><br/>
                <b>License:</b> 45673<br/>
                <b>Type:</b> Money Transmitter<br/>
                <b>State Agency:</b> Indiana Department of Financial Institutions
                  (<a target='_blank' href='http://www.in.gov/dfi'>http://www.in.gov/dfi</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Iowa</b><br/>
                <b>License:</b> 2019-0007<br/>
                <b>Type:</b> Money Services License<br/>
                <b>State Agency:</b> Iowa Division of Banking Finance Bureau
                  (<a target='_blank' href='https://idob.iowa.gov/'>https://idob.iowa.gov/</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Kansas</b><br/>
                <b>License:</b> MT.0000105<br/>
                <b>Type:</b> Money Transmitter<br/>
                <b>State Agency:</b> Kansas Office of the State Bank Commissioner
                  (<a target='_blank' href='http://www.osbckansas.org/'>http://www.osbckansas.org/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Kentucky</b><br/>
                <b>License:</b> SC700761<br/>
                <b>Type:</b> Money Transmitter<br/>
                <b>State Agency:</b> Kentucky Department of Financial Institutions
                  (<a target='_blank' href='https://kfi.ky.gov/'>https://kfi.ky.gov/</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Louisiana</b><br/>
                <b>License:</b> 374<br/>
                <b>Type:</b> Sale of Checks and Money Transmitters<br/>
                <b>State Agency:</b> Louisiana Office of Financial Institutions
                  (<a target='_blank' href='https://ofi.la.gov/'>https://ofi.la.gov/</a>)
                <br/><br/>
                <b>License:</b> 2636<br/>
                <b>Type:</b> Check Casher License<br/>
                <b>State Agency:</b> Louisiana Office of Financial Institutions
                  (<a target='_blank' href='https://ofi.la.gov/'>https://ofi.la.gov/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Maine</b><br/>
                <b>License:</b> No number<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> Department of Professional and Financial Regulation
                  (<a target='_blank' href='https://www.maine.gov/pfr/home'>https://www.maine.gov/pfr/home</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Maryland</b><br/>
                <b>License:</b> 937962<br/>
                <b>Type:</b> Money Transmitter<br/>
                <b>State Agency:</b> Maryland Office of the Commissioner of Financial Regulation
                  (<a target='_blank' href='http://www.dllr.state.md.us/finance/'>http://www.dllr.state.md.us/finance/</a>)
                <br/><br/>
                <b>License:</b> 937962<br/>
                <b>Type:</b> Check Cashing Services License<br/>
                <b>State Agency:</b> Maryland Office of the Commissioner of Financial Regulation
                  (<a target='_blank' href='http://www.dllr.state.md.us/finance/'>http://www.dllr.state.md.us/finance/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Massachusetts</b><br/>
                <b>License:</b> FT937962<br/>
                <b>Type:</b> Foreign Transmittal Agency<br/>
                <b>State Agency:</b> Massachusetts Division of Banks
                  (<a target='_blank' href='http://www.mass.gov/dob'>http://www.mass.gov/dob</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Michigan</b><br/>
                <b>License:</b> MT0020894<br/>
                <b>Type:</b> Money Transmitter<br/>
                <b>State Agency:</b> Michigan Department of Financial and Insurance Services
                  (<a target='_blank' href='https://www.michigan.gov/difs'>https://www.michigan.gov/difs</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Minnesota</b><br/>
                <b>License:</b> MN-MT-937962<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> Minnesota Department of Commerce
                  (<a target='_blank' href='https://mn.gov/commerce/'>https://mn.gov/commerce/</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Mississippi</b><br/>
                <b>License:</b> 2534<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> Department of Banking and Consumer Finance
                  (<a target='_blank' href='https://dbcf.ms.gov/'>https://dbcf.ms.gov/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Missouri</b><br/>
                <b>License:</b> MO-23-7801<br/>
                <b>Type:</b> Sale of Checks and Money Transmitter License<br/>
                <b>State Agency:</b> Missouri Division of Finance
                  (<a target='_blank' href='http://finance.mo.gov/'>http://finance.mo.gov/</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Nebraska</b><br/>
                <b>License:</b> No number<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> Nebraska Department of Banking and Finance
                  (<a target='_blank' href='https://ndbf.nebraska.gov/'>https://ndbf.nebraska.gov/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Nevada</b><br/>
                <b>License:</b> MT11203<br/>
                <b>Type:</b> Money Transmitter<br/>
                <b>State Agency:</b> Nevada Financial Institutions Division
                  (<a target='_blank' href='http://fid.nv.gov/'>http://fid.nv.gov/</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>New Jersey</b><br/>
                <b>License:</b> 2305801 C22<br/>
                <b>Type:</b> Money Transmitter<br/>
                <b>State Agency:</b> New Jersey Department of Banking and Insurance
                  (<a target='_blank' href='http://www.state.nj.us/dobi/index.html'>http://www.state.nj.us/dobi/index.html</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>New Hampshire</b><br/>
                <b>License:</b> 23714-MT<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> State of NH Banking Department
                  (<a target='_blank' href='https://www.banking.nh.gov/'>https://www.banking.nh.gov/</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>New Mexico</b><br/>
                <b>License:</b> No number<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> Financial Institutions Division
                  (<a target='_blank' href='https://www.rld.nm.gov/financial-institutions/'>https://www.rld.nm.gov/financial-institutions/</a>)
                <br/><br/>
                <b>License:</b> No number<br/>
                <b>Type:</b> Check Casher License<br/>
                <b>State Agency:</b> Financial Institutions Division
                  (<a target='_blank' href='https://www.rld.nm.gov/financial-institutions/'>https://www.rld.nm.gov/financial-institutions/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>North Carolina</b><br/>
                <b>License:</b> 164586<br/>
                <b>Type:</b> MMoney Transmitter License<br/>
                <b>State Agency:</b> North Carolina Commissioner of Banks
                  (<a target='_blank' href='https://www.nccob.org/'>https://www.nccob.org/</a>)
                <br/><br/>
                <b>License:</b> 1880437-4<br/>
                <b>Type:</b> Check cashing License<br/>
                <b>State Agency:</b> North Carolina Commissioner of Banks
                  (<a target='_blank' href='https://www.nccob.org/'>https://www.nccob.org/</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>North Dakota</b><br/>
                <b>License:</b> MT103382<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> ND Dept. of Financial Institutions
                  (<a target='_blank' href='https://www.nd.gov/dfi/'>https://www.nd.gov/dfi/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Ohio</b><br/>
                <b>License:</b> OHMT156<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> Ohio Division of Financial Institutions
                  (<a target='_blank' href='https://com.ohio.gov/divisions-and-programs/financial-institutions/financial-institutions'>https://com.ohio.gov/divisions-and-programs/financial-institutions/financial-institutions</a>)
                <br/><br/>
                <b>License:</b> CC-700888.000<br/>
                <b>Type:</b> Check-Cashing License<br/>
                <b>State Agency:</b> Ohio Division of Financial Institutions
                  (<a target='_blank' href='https://com.ohio.gov/divisions-and-programs/financial-institutions/financial-institutions'>https://com.ohio.gov/divisions-and-programs/financial-institutions/financial-institutions</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Oklahoma</b><br/>
                <b>License:</b> OKDOB001<br/>
                <b>Type:</b> Money Transmission License<br/>
                <b>State Agency:</b> Oklahoma Banking Department
                  (<a target='_blank' href='https://www.ok.gov/banking/'>https://www.ok.gov/banking/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Oregon</b><br/>
                <b>License:</b> 937962<br/>
                <b>Type:</b> Money Transmitter<br/>
                <b>State Agency:</b> Oregon Division of Financial Regulation
                  (<a target='_blank' href='http://dfr.oregon.gov/'>http://dfr.oregon.gov/</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Pennsylvania</b><br/>
                <b>License:</b> 75303<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> Pennsylvania Department of Banking and Securities
                  (<a target='_blank' href='http://www.banking.state.pa.us/'>http://www.banking.state.pa.us/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Puerto Rico</b><br/>
                <b>License:</b> TM-111<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> Puerto Rico Oficina del Comisionado de Instituciones Financieras
                  (<a target='_blank' href='http://www.ocif.pr.gov/'>http://www.ocif.pr.gov/</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Rhode Island</b><br/>
                <b>License:</b> 20203898CT<br/>
                <b>Type:</b> Currency Transmitter License<br/>
                <b>State Agency:</b> Rhode Island Department of Business Regulation - Banking Division
                  (<a target='_blank' href='https://dbr.ri.gov/divisions/banking/'>https://dbr.ri.gov/divisions/banking/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>South Carolina</b><br/>
                <b>License:</b> No number<br/>
                <b>Type:</b> Money Transmission License<br/>
                <b>State Agency:</b> South Carolina Office of the Attorney General
                  (<a target='_blank' href='http://www.scag.gov/civil/money-services'>http://www.scag.gov/civil/money-services</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>South Dakota</b><br/>
                <b>License:</b> 937962.MT<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> South Dakota Division of Banking
                  (<a target='_blank' href='https://dlr.sd.gov/banking/default.aspx'>https://dlr.sd.gov/banking/default.aspx</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Tennessee</b><br/>
                <b>License:</b> 937962<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> Tennessee Department of Financial Institutions
                  (<a target='_blank' href='http://www.tennessee.gov/tdfi/'>http://www.tennessee.gov/tdfi/</a>)
                <br/><br/>
                <b>License:</b> 168822<br/>
                <b>Type:</b> Check Casher License<br/>
                <b>State Agency:</b> Tennessee Department of Financial Institutions
                  (<a target='_blank' href='http://www.tennessee.gov/tdfi/'>http://www.tennessee.gov/tdfi/</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Texas</b><br/>
                <b>License:</b> 2301<br/>
                <b>Type:</b> Money Transmission License<br/>
                <b>State Agency:</b> Texas Department of Banking
                  (<a target='_blank' href='http://www.dob.texas.gov/'>http://www.dob.texas.gov/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Utah</b><br/>
                <b>License:</b> 145<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> Utah Department of Financial Institutions
                  (<a target='_blank' href='https://dfi.utah.gov/'>https://dfi.utah.gov/</a>)
                <br/><br/>
                <b>License:</b> No number<br/>
                <b>Type:</b> Check cashing License<br/>
                <b>State Agency:</b> Utah Department of Financial Institutions
                  (<a target='_blank' href='https://dfi.utah.gov/'>https://dfi.utah.gov/</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Vermont</b><br/>
                <b>License:</b> 100-128<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> Vermont Department of Financial Regulation
                  (<a target='_blank' href='https://dfr.vermont.gov/'>https://dfr.vermont.gov/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Virginia</b><br/>
                <b>License:</b> MO-406<br/>
                <b>Type:</b> Money Order Seller and Money Transmitter License<br/>
                <b>State Agency:</b> Virginia State Corporation Commission - Bureau of Financial Institutions
                  (<a target='_blank' href='http://www.scc.virginia.gov/bfi/index.aspx'>http://www.scc.virginia.gov/bfi/index.aspx</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Washington</b><br/>
                <b>License:</b> 550-MT-117332<br/>
                <b>Type:</b> Money Transmission License<br/>
                <b>State Agency:</b> Washington State Department of Financial Institutions
                  (<a target='_blank' href='http://www.dfi.wa.gov/'>http://www.dfi.wa.gov/</a>)
                <br/><br/>
                <b>License:</b> 530-CC-117331<br/>
                <b>Type:</b> Check Casher License<br/>
                <b>State Agency:</b> Washington State Department of Financial Institutions
                  (<a target='_blank' href='http://www.dfi.wa.gov/'>http://www.dfi.wa.gov/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>West Virginia</b><br/>
                <b>License:</b> WVMT-937962<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> Division of Financial Institutions
                  (<a target='_blank' href='https://dfi.wv.gov/Pages/default.aspx'>https://dfi.wv.gov/Pages/default.aspx</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Wisconsin</b><br/>
                <b>License:</b> 205-SOC<br/>
                <b>Type:</b> Sale of Checks<br/>
                <b>State Agency:</b> Wisconsin Department of Financial Institutions
                  (<a target='_blank' href='http://wdfi.org/'>http://wdfi.org/</a>)
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>Wyoming</b><br/>
                <b>License:</b> 7254<br/>
                <b>Type:</b> Money Transmitter License<br/>
                <b>State Agency:</b> Wyoming Division of Banking
                  (<a target='_blank' href='https://wyomingbankingdivision.wyo.gov/'>https://wyomingbankingdivision.wyo.gov/</a>)
              </td>
              <td className="td4" valign="top" style={{ borderTop : 'none', textAlign : 'center' }}>
                <b>New York</b><br/>
                <b>License:</b> MT-105096<br/>
                <b>Type:</b> Money Transmission<br/>
                <b>State Agency:</b> New York State Department of Financial Services
                  (<a target='_blank' href='https://www.dfs.ny.gov/complaint'>https://www.dfs.ny.gov/complaint</a>)
              </td>
            </tr> */}

          </tbody>
        </table>
      </div>
    )
  },

});


module.exports = BfgStatesLLC



// WEBPACK FOOTER //
// ./js/StatesLLC.js